//Imports
import React, { useMemo } from "react";

//Hooks
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

//Controls
import { Tabs, TabContainer, Container } from "@gpstrackit/gtc-react-controls";

//Utils
import { HasPermission } from "Core/security";

//Tabs
import KeyFobsTab from "../keyFobsTab";
import CrewTab from "../crewTab";
import TemperatureTab from "../temperatureTab";
import EquipmentTab from "../equipmentTab";
import FuelCardTab from "../fuelCardTab";
import DriverStatusTab from "../driverStatusTab";
import LocationsTab from "../locationsTab";
import UnitSettings from 'Modules/fleet/views/main';
import BehaviorConfigView from "../behaviorTab";
import InputsTab from "../inputsTab";
import CameraManagementTab from "../cameraManagementTab";
import ModalWarnings from 'Modules/.common/components/Warnings';
import CameraSetup from 'Modules/.common/components/CameraSetup';
import VehicleStatusTab from "../vehicleStatusTab";
import DriverTab from "../../../driver"
import AssetTab from "../assetTab";
import AssetSubtype from "../assetSubtype";
import WorkOrderStatus from "../workOrderStatus";
import WorkOrderType from "../workOrderType";

const ManageMainView = () => {

  //Language
  const { messages } = useIntl();

    //Global state
  const openModalCameraSetup = useSelector((state) => state.cameraSetupRedux.open);
  const openModalWarnings = useSelector(state => state.warningsRedux.open);

  //URL Params
  const { id } = useParams();

  //Redux
  const user = useSelector((state) => state.securityRedux.user);

  //Tabs
  const tabs = [
    {
      label: messages['settings_unit_settings'],
      master: "",
      subUser: [13],
      component: <UnitSettings moduleUnitSettings={true} />
    },
    {
      label:  messages['settings_assets'],
      master: "ast",
      subUser: [312],
      component: <AssetTab />
    },
    { // TODO submodule-approved
      label: messages['settings_asset_subtypes'],
      master: "aststp",
      subUser: [313],
      component: <AssetSubtype />
    },
    {
      label: messages["manage_fuelCard"],
      master: "fuel",
      subUser: [49],
      component: <FuelCardTab />
    },
    {
      label: messages["manage_crew"],
      master: "cwm",
      subUser: [126],
      component: <CrewTab />
    },
    {
      label: messages["manage_keyFobs"],
      master: "ckeyfob",
      subUser: [42],
      component: <KeyFobsTab />
    },
    ,
    {
      label: messages["manage_vehicleStatus"],
      master: "",
      subUser: [43],
      component: <VehicleStatusTab />
    },
    {
      label: messages["manage_temperature"],
      master: "ctemp",
      subUser: [46],
      component: <TemperatureTab />
    },
    {
      label: messages["manage_equipment"],
      master: "ve",
      subUser: [25],
      component: <EquipmentTab />
    }
  ];

  const modulesConditional = [ 
    { 
      label: messages["manage_driverStatus"],
      master: ["dappdst"],
      subUser: [249],
      component: <DriverStatusTab />
    },
    { 
      label: messages["manage_cameraManagement"],
      master: ["mediamanagecam"],
      subUser: [209],
      component: <CameraManagementTab />
    },
    {
      label: messages["settings_drivers"],
      master: ["driver"],
      subUser: [17],
      component: <DriverTab />
    },
  ]

  const modulesAditional = [
    { 
      label: messages["manage_location"],
      subUser: [44],
      component: <LocationsTab />
    },
    {
      label: messages["manage_behavior"],
      master: ["behavior"],
      subUser: [284],
      component: <BehaviorConfigView  />
    },
    { // TODO submodule-approved
      label: messages['settings_work_order_types'],
      master: "workorders",
      subUser: [289],
      component: <WorkOrderType />
    },
    { // TODO submodule-approved
      label: messages['settings_work_order_status'],
      master: "workorders",
      subUser: [289],
      component: <WorkOrderStatus />
    }
  ]

  const modulesReport = [
    {
      label: messages["manage_inputs"],
      master: "",
      subUser: [225],
      component: <InputsTab />
    }
  ];

  const filteredTabs = useMemo(() => [
    ...tabs.filter((tab) => HasPermission(user, tab.master, tab.subUser)),
    ...modulesReport.filter(tab => HasPermission(user, "", tab.subUser)),
    ...modulesConditional.filter(tab => !HasPermission(user, 'apu-control', null) && (HasPermission(user, tab.master || "", tab.subUser) || user.dealerId === "28")),
    ...modulesAditional.filter(tab => !HasPermission(user, 'apu-control', null) && HasPermission(user, tab.master || "", tab.subUser)),
  ], [user, tabs, modulesConditional]);

  return (
    <Container maxWidth={false} className="container-view">
      <Tabs tab={id?.length > 0 ? parseInt(id) : 0}>
        {filteredTabs.map((item, index) => {
          const { label, component } = item;
          return (
            <TabContainer key={index} label={label} index={index}>
              {component}
            </TabContainer>
          );
        })}
      </Tabs>
      {openModalWarnings && <ModalWarnings />}
      {openModalCameraSetup && <CameraSetup />}
    </Container>
  );
};

export default ManageMainView;